// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Базові стилі застосунку RCT Cash.
 *
 * Принципи:
 *  1. Mobile-first — базові правила описують телефон, медіа-запити
 *     розширюють макет для планшета й десктопа.
 *  2. Жодних !important-хаків поверх PrimeReact: фірмові кольори
 *     вшиті в саму тему (scripts/build-theme.js).
 *  3. Всі значення — з src/theme/tokens.css.
 */

/* ─────────────────────────────────────────────────────────────────────
   Скидання й типографіка
   ───────────────────────────────────────────────────────────────────── */

*,
*::before,
*::after {
    box-sizing: border-box;
}

html {
    /* Не даємо iOS збільшувати шрифт у ландшафті */
    -webkit-text-size-adjust: 100%;
}

body {
    margin: 0;
    min-height: 100vh;
    background: var(--rc-bg);
    color: var(--rc-text);
    font-family: var(--rc-font);
    font-size: 15px;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* Прибирає сіру підсвітку при тапі на Android/iOS */
    -webkit-tap-highlight-color: transparent;
}

.p-component,
.p-inputtext {
    font-family: var(--rc-font);
}

/* Суми завжди моноширинними цифрами — колонки чисел не «стрибають» */
.rc-money,
.rc-summary-row__value,
.rc-stat__value,
.p-inputnumber-input,
.rc-catalog-tile__price {
    font-variant-numeric: tabular-nums;
    font-feature-settings: 'tnum';
}

.rc-money {
    font-weight: 600;
    white-space: nowrap;
}

.rc-money--income {
    color: var(--rc-income-strong);
}

.rc-money--outcome {
    color: var(--rc-outcome-strong);
}

/* ─────────────────────────────────────────────────────────────────────
   Каркас застосунку
   ───────────────────────────────────────────────────────────────────── */

.rc-shell {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-height: 100dvh;
}

.rc-main {
    flex: 1 1 auto;
    width: 100%;
    max-width: var(--rc-content-max);
    margin: 0 auto;
    padding: var(--rc-space-4) var(--rc-space-3);
    /* Знизу лишаємо місце під таб-бар і жестову смугу iPhone */
    padding-bottom: calc(var(--rc-bottom-nav-h) + var(--rc-safe-bottom) + var(--rc-space-4));
}

.rc-main--wide {
    max-width: 96rem;
}

/* Вузька колонка всередині широкого контейнера — для підсумків,
   форм і всього, що погано читається розтягнутим */
.rc-narrow {
    width: 100%;
    max-width: 40rem;
    margin-left: auto;
    margin-right: auto;
}

@media (min-width: 768px) {
    .rc-main {
        padding: var(--rc-space-5) var(--rc-space-4);
        padding-bottom: calc(var(--rc-bottom-nav-h) + var(--rc-safe-bottom) + var(--rc-space-5));
    }
}

@media (min-width: 1024px) {
    /* На десктопі нижньої навігації немає — забираємо резерв місця */
    .rc-main {
        padding-bottom: var(--rc-space-6);
    }
}

/* ── Верхня панель ──────────────────────────────────────────────────── */

.rc-header {
    position: sticky;
    top: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    gap: var(--rc-space-3);
    height: calc(var(--rc-header-h) + var(--rc-safe-top));
    padding: var(--rc-safe-top) var(--rc-space-3) 0;
    background: var(--rc-brand-black);
    color: #fff;
}

.rc-header__brand {
    display: flex;
    align-items: center;
    gap: var(--rc-space-2);
    min-width: 0;
    text-decoration: none;
    color: inherit;
    background: none;
    border: 0;
    padding: 0;
    cursor: pointer;
}

.rc-header__logo {
    width: 1.75rem;
    height: 1.75rem;
    flex: none;
    object-fit: contain;
}

.rc-header__wordmark {
    font-size: 1.0625rem;
    font-weight: 700;
    letter-spacing: -0.01em;
    white-space: nowrap;
}

.rc-header__wordmark em {
    font-style: normal;
    color: var(--rc-brand-red);
}

.rc-header__context {
    display: none;
    min-width: 0;
    flex: 1 1 auto;
    align-items: center;
    gap: var(--rc-space-2);
}

@media (min-width: 640px) {
    .rc-header__context {
        display: flex;
    }
}

.rc-header__division {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.8125rem;
    color: rgba(255, 255, 255, 0.65);
}

.rc-header__spacer {
    flex: 1 1 auto;
}

.rc-header__actions {
    display: flex;
    align-items: center;
    gap: var(--rc-space-1);
    flex: none;
}

/* Кнопки в темній шапці */
.rc-header .p-button.p-button-text,
.rc-header .p-button.p-button-outlined {
    color: rgba(255, 255, 255, 0.85);
    border-color: rgba(255, 255, 255, 0.2);
    min-width: var(--rc-touch-target);
    height: var(--rc-touch-target);
}

.rc-header .p-button.p-button-text:enabled:hover,
.rc-header .p-button.p-button-outlined:enabled:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: rgba(255, 255, 255, 0.35);
}

/* ── Індикатор стану зміни ─────────────────────────────────────────── */

.rc-shift-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.25rem 0.625rem;
    border-radius: var(--rc-radius-pill);
    font-size: 0.75rem;
    font-weight: 600;
    white-space: nowrap;
}

.rc-shift-badge__dot {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background: currentColor;
    flex: none;
}

.rc-shift-badge--open {
    background: rgba(22, 163, 74, 0.16);
    color: #4ade80;
}

.rc-shift-badge--closed {
    background: rgba(255, 255, 255, 0.12);
    color: rgba(255, 255, 255, 0.7);
}

/* Той самий бейдж на світлому фоні (усередині карток) */
.rc-shift-badge--on-light.rc-shift-badge--open {
    background: var(--rc-income-soft);
    color: var(--rc-income-strong);
}

.rc-shift-badge--on-light.rc-shift-badge--closed {
    background: var(--rc-neutral-soft);
    color: var(--rc-neutral);
}

/* ── Нижня навігація (телефон і планшет) ───────────────────────────── */

.rc-bottom-nav {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    display: flex;
    align-items: stretch;
    height: calc(var(--rc-bottom-nav-h) + var(--rc-safe-bottom));
    padding-bottom: var(--rc-safe-bottom);
    background: var(--rc-surface);
    border-top: 1px solid var(--rc-border);
    box-shadow: 0 -1px 3px rgba(20, 21, 26, 0.05);
}

@media (min-width: 1024px) {
    .rc-bottom-nav {
        display: none;
    }
}

.rc-bottom-nav__item {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.1875rem;
    padding: var(--rc-space-1);
    border: 0;
    background: none;
    color: var(--rc-text-subtle);
    font-family: inherit;
    font-size: 0.6875rem;
    font-weight: 500;
    line-height: 1.2;
    cursor: pointer;
    position: relative;
    transition: color 0.15s;
}

.rc-bottom-nav__item i {
    font-size: 1.25rem;
}

.rc-bottom-nav__item:hover {
    color: var(--rc-text-muted);
}

.rc-bottom-nav__item--active {
    color: var(--rc-brand-red);
}

.rc-bottom-nav__item--active::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 2rem;
    height: 3px;
    border-radius: 0 0 3px 3px;
    background: var(--rc-brand-red);
}

.rc-bottom-nav__badge {
    position: absolute;
    top: 0.375rem;
    left: 50%;
    margin-left: 0.375rem;
    min-width: 1.125rem;
    height: 1.125rem;
    padding: 0 0.25rem;
    border-radius: var(--rc-radius-pill);
    background: var(--rc-brand-red);
    color: #fff;
    font-size: 0.625rem;
    font-weight: 700;
    line-height: 1.125rem;
    text-align: center;
}

/* ── Бічне меню (десктоп + «Ще» на мобільному) ─────────────────────── */

.rc-menu-panel {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.rc-menu-panel__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--rc-space-3);
    padding: var(--rc-space-4);
    border-bottom: 1px solid var(--rc-border);
}

.rc-menu-panel__body {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: var(--rc-space-3);
}

.rc-menu-panel__footer {
    padding: var(--rc-space-4);
    border-top: 1px solid var(--rc-border);
}

.rc-menu-section-title {
    padding: var(--rc-space-3) var(--rc-space-2) var(--rc-space-2);
    font-size: 0.6875rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--rc-text-subtle);
}

.rc-menu-item {
    display: flex;
    width: 100%;
    align-items: center;
    gap: var(--rc-space-3);
    min-height: var(--rc-touch-target);
    padding: var(--rc-space-2) var(--rc-space-3);
    border: 0;
    border-radius: var(--rc-radius-sm);
    background: none;
    color: var(--rc-text);
    font-family: inherit;
    font-size: 0.9375rem;
    text-align: left;
    cursor: pointer;
    transition: background 0.15s;
}

.rc-menu-item:hover {
    background: var(--rc-neutral-soft);
}

.rc-menu-item i {
    font-size: 1.125rem;
    color: var(--rc-text-muted);
    flex: none;
}

.rc-menu-item__label {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
}

.rc-menu-item--active {
    background: var(--rc-outcome-soft);
    color: var(--rc-brand-red-dark);
    font-weight: 600;
}

.rc-menu-item--active i {
    color: var(--rc-brand-red);
}

.rc-menu-user {
    display: flex;
    align-items: center;
    gap: var(--rc-space-3);
    min-width: 0;
}

.rc-menu-user__name {
    display: block;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.rc-menu-user__meta {
    display: block;
    font-size: 0.8125rem;
    color: var(--rc-text-muted);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* ─────────────────────────────────────────────────────────────────────
   Картки й типові блоки
   ───────────────────────────────────────────────────────────────────── */

.rc-stack {
    display: flex;
    flex-direction: column;
    gap: var(--rc-space-4);
}

.rc-stack--tight {
    gap: var(--rc-space-2);
}

.rc-card {
    background: var(--rc-surface);
    border: 1px solid var(--rc-border);
    border-radius: var(--rc-radius);
    box-shadow: var(--rc-shadow-sm);
    overflow: hidden;
}

.rc-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--rc-space-3);
    padding: var(--rc-space-3) var(--rc-space-4);
    border-bottom: 1px solid var(--rc-border);
}

.rc-card__title {
    margin: 0;
    font-size: 0.9375rem;
    font-weight: 600;
    color: var(--rc-text);
}

.rc-card__subtitle {
    margin: 0.125rem 0 0;
    font-size: 0.8125rem;
    font-weight: 400;
    color: var(--rc-text-muted);
}

.rc-card__body {
    padding: var(--rc-space-4);
}

.rc-card__body--flush {
    padding: 0;
}

.rc-page-title {
    margin: 0 0 var(--rc-space-1);
    font-size: 1.375rem;
    font-weight: 700;
    letter-spacing: -0.02em;
}

.rc-page-subtitle {
    margin: 0;
    color: var(--rc-text-muted);
    font-size: 0.875rem;
}

/* ── Списки сум ─────────────────────────────────────────────────────── */

.rc-summary-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.rc-summary-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--rc-space-3);
    padding: var(--rc-space-3) var(--rc-space-4);
    border-top: 1px solid var(--rc-border);
}

.rc-summary-row:first-child {
    border-top: 0;
}

.rc-summary-row__label {
    color: var(--rc-text-muted);
    font-size: 0.875rem;
    min-width: 0;
}

.rc-summary-row__sub {
    display: block;
    font-size: 0.75rem;
    color: var(--rc-text-subtle);
}

.rc-summary-row__value {
    font-weight: 600;
    text-align: right;
    white-space: nowrap;
}

.rc-summary-row__value--stack {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.125rem;
}

.rc-summary-row--total {
    background: var(--rc-surface-sunken);
}

.rc-summary-row--total .rc-summary-row__label {
    color: var(--rc-text);
    font-weight: 600;
}

.rc-summary-row--total .rc-summary-row__value {
    font-size: 1.125rem;
}

/* ── Плитки-показники ──────────────────────────────────────────────── */

.rc-stat-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(8.5rem, 1fr));
    gap: var(--rc-space-3);
}

.rc-stat {
    padding: var(--rc-space-3) var(--rc-space-4);
    border: 1px solid var(--rc-border);
    border-radius: var(--rc-radius);
    background: var(--rc-surface);
}

.rc-stat__label {
    display: flex;
    align-items: center;
    gap: var(--rc-space-2);
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: var(--rc-text-subtle);
}

.rc-stat__value {
    margin-top: var(--rc-space-1);
    font-size: 1.375rem;
    font-weight: 700;
    letter-spacing: -0.02em;
}

.rc-stat__value--sm {
    font-size: 1.0625rem;
}

/* ── Головні дії (екран зміни) ─────────────────────────────────────── */

.rc-action-grid {
    display: grid;
    gap: var(--rc-space-3);
    grid-template-columns: 1fr;
}

@media (min-width: 600px) {
    .rc-action-grid--split {
        grid-template-columns: 1fr 1fr;
    }
}

.rc-action {
    display: flex;
    align-items: center;
    gap: var(--rc-space-3);
    width: 100%;
    min-height: 4.25rem;
    padding: var(--rc-space-3) var(--rc-space-4);
    border: 1px solid var(--rc-border);
    border-radius: var(--rc-radius);
    background: var(--rc-surface);
    box-shadow: var(--rc-shadow-sm);
    color: var(--rc-text);
    font-family: inherit;
    font-size: 1rem;
    text-align: left;
    cursor: pointer;
    transition: transform 0.12s, box-shadow 0.15s, border-color 0.15s;
}

.rc-action:hover {
    box-shadow: var(--rc-shadow);
    border-color: var(--rc-border-strong);
}

.rc-action:active {
    transform: scale(0.99);
}

.rc-action:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    box-shadow: none;
}

.rc-action__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.75rem;
    height: 2.75rem;
    flex: none;
    border-radius: var(--rc-radius-sm);
    font-size: 1.25rem;
}

.rc-action__text {
    flex: 1 1 auto;
    min-width: 0;
}

.rc-action__title {
    font-weight: 600;
    display: block;
}

.rc-action__hint {
    display: block;
    font-size: 0.8125rem;
    color: var(--rc-text-muted);
}

.rc-action__chevron {
    color: var(--rc-text-subtle);
    flex: none;
}

.rc-action--income .rc-action__icon {
    background: var(--rc-income-soft);
    color: var(--rc-income-strong);
}

.rc-action--outcome .rc-action__icon {
    background: var(--rc-outcome-soft);
    color: var(--rc-outcome-strong);
}

.rc-action--neutral .rc-action__icon {
    background: var(--rc-neutral-soft);
    color: var(--rc-neutral);
}

.rc-action--primary {
    background: var(--rc-brand-black);
    border-color: var(--rc-brand-black);
    color: #fff;
}

.rc-action--primary .rc-action__icon {
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
}

.rc-action--primary .rc-action__hint,
.rc-action--primary .rc-action__chevron {
    color: rgba(255, 255, 255, 0.7);
}

/* ─────────────────────────────────────────────────────────────────────
   Каталог товарів (екран продажу)
   ───────────────────────────────────────────────────────────────────── */

.rc-catalog-toolbar {
    position: sticky;
    top: calc(var(--rc-header-h) + var(--rc-safe-top));
    z-index: 900;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--rc-space-2);
    padding: var(--rc-space-2) var(--rc-space-3);
    background: rgba(244, 245, 247, 0.92);
    -webkit-backdrop-filter: blur(8px);
            backdrop-filter: blur(8px);
    border-bottom: 1px solid var(--rc-border);
}

.rc-catalog-toolbar .p-inputtext {
    width: 100%;
}

.rc-catalog-toolbar__search {
    flex: 1 1 8rem;
    min-width: 0;
}

/* Перемикач «Товари / Послуги»: на телефоні — окремим рядком на всю
   ширину, з рівними половинами; від 600px стає в один ряд із пошуком. */
.rc-catalog-toolbar__kind {
    flex: 1 1 100%;
    order: -1;
}

.rc-catalog-toolbar__kind .p-selectbutton {
    display: flex;
    width: 100%;
}

.rc-catalog-toolbar__kind .p-selectbutton .p-button {
    flex: 1 1;
    justify-content: center;
    white-space: nowrap;
    padding-left: var(--rc-space-4);
    padding-right: var(--rc-space-4);
}

@media (min-width: 600px) {
    .rc-catalog-toolbar__kind {
        flex: 0 0 auto;
        order: 0;
        width: auto;
    }

    .rc-catalog-toolbar__kind .p-selectbutton {
        width: auto;
        gap: var(--rc-space-2);
    }

    /* Скидаємо мобільне розтягування, інакше підписи кнопок
       стискаються й накладаються один на одного */
    .rc-catalog-toolbar__kind .p-selectbutton .p-button {
        flex: 0 0 auto;
        min-width: 7.5rem;
    }

    /* SelectButton за замовчуванням склеює кнопки в одну «таблетку»:
       у сусідніх кнопок зрізані радіуси й прибрана ліва межа. Оскільки
       ми рознесли їх проміжком, повертаємо кожній повний вигляд. */
    .rc-catalog-toolbar__kind .p-selectbutton .p-button,
    .rc-catalog-toolbar__kind .p-selectbutton .p-button:first-of-type,
    .rc-catalog-toolbar__kind .p-selectbutton .p-button:last-of-type {
        border-radius: var(--rc-radius-sm);
        border-left-width: 1px;
    }

    /* Пошук не має розтягуватися на весь вільний простір —
       поруч із ним і так порожньо, а довге поле читається гірше */
    .rc-catalog-toolbar__search {
        flex: 0 1 22rem;
    }
}

/* min-width, а не width: кнопка з підписом або лічильником має право
   стати ширшою. З жорсткою шириною кошик обрізав власний бейдж. */
.rc-catalog-toolbar .p-button {
    flex: none;
    min-width: var(--rc-touch-target);
    height: var(--rc-touch-target);
}

.rc-breadcrumb {
    display: flex;
    align-items: center;
    gap: var(--rc-space-2);
    flex-wrap: wrap;
    padding: var(--rc-space-3) 0 0;
    font-size: 0.875rem;
    color: var(--rc-text-muted);
}

.rc-breadcrumb__chip {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.25rem 0.625rem;
    border-radius: var(--rc-radius-pill);
    background: var(--rc-surface);
    border: 1px solid var(--rc-border);
}

.rc-catalog-grid {
    display: grid;
    /* auto-fill + minmax: колонки самі підлаштовуються під ширину
       колонки-контейнера, тому сітка ніколи не «вилазить» під кошик */
    grid-template-columns: repeat(auto-fill, minmax(8.5rem, 1fr));
    gap: var(--rc-space-3);
}

/* На великому екрані плитка — основна ціль для миші й пальця,
   тому вона помітно більша, ніж у щільній мобільній сітці */
@media (min-width: 1024px) {
    .rc-catalog-grid {
        grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
        gap: var(--rc-space-4);
    }
}

.rc-catalog-tile {
    display: flex;
    flex-direction: column;
    /* min-width: 0 обов'язковий: без нього довга назва товару розтягує
       колонку grid-у і ламає макет */
    min-width: 0;
    min-height: 8.5rem;
    padding: var(--rc-space-3);
    border: 1px solid var(--rc-border);
    border-radius: var(--rc-radius);
    background: var(--rc-surface);
    box-shadow: var(--rc-shadow-sm);
    color: var(--rc-text);
    font-family: inherit;
    text-align: left;
    cursor: pointer;
    transition: transform 0.12s, box-shadow 0.15s, border-color 0.15s;
}

.rc-catalog-tile:hover {
    box-shadow: var(--rc-shadow);
    border-color: var(--rc-border-strong);
}

.rc-catalog-tile:active {
    transform: scale(0.98);
}

.rc-catalog-tile__media {
    flex: 0 0 auto;
    height: 3.5rem;
    margin-bottom: var(--rc-space-2);
    border-radius: var(--rc-radius-sm);
    background-color: var(--rc-surface-sunken);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--rc-text-subtle);
    font-size: 1.75rem;
}

/* На телефоні порожній плейсхолдер лише крав би місце в назви */
.rc-catalog-tile__media--empty {
    display: none;
}

.rc-catalog-tile__name {
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.3;
    /* Обрізаємо довгі назви двома рядками замість зменшення шрифту */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.rc-catalog-tile__meta {
    margin-top: 0.125rem;
    font-size: 0.75rem;
    color: var(--rc-text-subtle);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.rc-catalog-tile__price {
    margin-top: auto;
    padding-top: var(--rc-space-2);
    font-weight: 700;
    font-size: 0.9375rem;
}

/* Групи товарів виглядають інакше, ніж самі товари */
.rc-catalog-tile--group {
    align-items: flex-start;
    /* Назва й підпис «Категорія» тримаються разом угорі: після
       збільшення плиток space-between розганяв їх по кутах */
    justify-content: flex-start;
    background: linear-gradient(180deg, var(--rc-surface) 0%, var(--rc-surface-sunken) 100%);
}

.rc-catalog-tile--group .rc-catalog-tile__meta {
    margin-top: 0.125rem;
}

.rc-catalog-tile--group .rc-catalog-tile__media {
    background: none;
    height: 2rem;
    justify-content: flex-start;
    color: var(--rc-brand-red);
}

.rc-catalog-tile--nav {
    min-height: 5rem;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: var(--rc-surface-sunken);
    box-shadow: none;
}

.rc-catalog-tile--nav .rc-catalog-tile__name {
    text-align: center;
    color: var(--rc-text-muted);
}

/* На десктопі плитка — основна ціль для миші: вища, з просторішим
   padding-ом і більшим шрифтом назви та ціни. Мобільна сітка щільна
   навмисно, тому ці розміри лишаються всередині медіа-запиту. */
@media (min-width: 1024px) {
    .rc-catalog-tile {
        min-height: 13.5rem;
        padding: var(--rc-space-4);
    }

    .rc-catalog-tile__media {
        height: 6rem;
        margin-bottom: var(--rc-space-3);
    }

    .rc-catalog-tile__media--empty {
        display: flex;
    }

    .rc-catalog-tile__name {
        font-size: 1rem;
    }

    .rc-catalog-tile__meta {
        font-size: 0.8125rem;
    }

    .rc-catalog-tile__price {
        font-size: 1.125rem;
        padding-top: var(--rc-space-3);
    }

    /* У категорії немає ні картинки, ні ціни, тож на високій плитці
       вміст центруємо — інакше під підписом лишається порожня третина */
    .rc-catalog-tile--group {
        justify-content: center;
    }

    .rc-catalog-tile--group .rc-catalog-tile__media {
        height: 3rem;
        font-size: 2.25rem;
    }
}

.rc-catalog-pager {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--rc-space-2);
    padding-top: var(--rc-space-4);
}

.rc-catalog-pager .p-button {
    flex: none;
}

.rc-catalog-pager .rc-page-subtitle {
    white-space: nowrap;
}

/* На вузькому екрані три підписи в один ряд не вміщаються, а flex: none
   не дає їм стиснутись — «Наступна» вилазила за межі екрана. Ховаємо
   текст візуально (не з DOM: доступна назва кнопки лишається). */
@media (max-width: 599px) {
    .rc-catalog-pager .p-button .p-button-label {
        position: absolute;
        width: 1px;
        height: 1px;
        overflow: hidden;
        clip-path: inset(50%);
        white-space: nowrap;
    }

    .rc-catalog-pager .p-button .p-button-icon {
        margin: 0;
    }
}

/* ── Вибір розділу (товари / послуги) ──────────────────────────────── */

.rc-picker-grid {
    display: grid;
    gap: var(--rc-space-4);
    grid-template-columns: 1fr;
}

@media (min-width: 600px) {
    .rc-picker-grid {
        grid-template-columns: 1fr 1fr;
    }
}

.rc-picker {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--rc-space-2);
    min-height: 9rem;
    padding: var(--rc-space-5);
    border: 1px solid var(--rc-border);
    border-radius: var(--rc-radius-lg);
    background: var(--rc-surface);
    box-shadow: var(--rc-shadow-sm);
    color: var(--rc-text);
    font-family: inherit;
    text-align: left;
    cursor: pointer;
    transition: transform 0.12s, box-shadow 0.15s;
}

.rc-picker:hover {
    box-shadow: var(--rc-shadow);
}

.rc-picker:active {
    transform: scale(0.99);
}

.rc-picker__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    border-radius: var(--rc-radius);
    background: var(--rc-outcome-soft);
    color: var(--rc-brand-red);
    font-size: 1.5rem;
}

.rc-picker__title {
    font-size: 1.125rem;
    font-weight: 700;
}

.rc-picker__hint {
    font-size: 0.875rem;
    color: var(--rc-text-muted);
}

/* ─────────────────────────────────────────────────────────────────────
   Кошик і списки позицій
   ───────────────────────────────────────────────────────────────────── */

.rc-line-item {
    display: flex;
    align-items: center;
    gap: var(--rc-space-3);
    padding: var(--rc-space-3) var(--rc-space-4);
    border-top: 1px solid var(--rc-border);
}

.rc-line-item:first-child {
    border-top: 0;
}

.rc-line-item__main {
    flex: 1 1 auto;
    min-width: 0;
}

.rc-line-item__name {
    font-weight: 600;
    font-size: 0.9375rem;
    overflow: hidden;
    text-overflow: ellipsis;
}

.rc-line-item__meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0 var(--rc-space-2);
    margin-top: 0.125rem;
    min-width: 0;
    font-size: 0.8125rem;
    color: var(--rc-text-muted);
}

.rc-line-item__side {
    display: flex;
    align-items: center;
    gap: var(--rc-space-2);
    flex: none;
}

/* Лічильник кількості — великі цілі для пальця */
.rc-stepper {
    display: inline-flex;
    align-items: center;
    border: 1px solid var(--rc-border);
    border-radius: var(--rc-radius-pill);
    background: var(--rc-surface);
    overflow: hidden;
}

.rc-stepper__btn {
    width: 2.25rem;
    height: 2.25rem;
    border: 0;
    background: none;
    color: var(--rc-text-muted);
    font-size: 0.875rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.rc-stepper__btn:hover:not(:disabled) {
    background: var(--rc-neutral-soft);
    color: var(--rc-text);
}

.rc-stepper__btn:disabled {
    opacity: 0.35;
    cursor: not-allowed;
}

.rc-stepper__value {
    min-width: 2rem;
    text-align: center;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
}

/* Перелік позицій на кроці оплати. Обмежуємо висоту: із двадцятьма
   позиціями кнопка «Оплатити» інакше опинялася б далеко за екраном,
   і касир мусив би гортати сторінку на кожен продаж. */
.rc-checkout-items {
    /* На телефоні висоту обмежуємо, інакше на великому замовленні кнопка
       «Оплатити» йде далеко за екран. 60vh — це 5-6 рядків, тобто типове
       замовлення вміщається повністю й нічого не обрізається. */
    max-height: 60vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    /* Згасання біля нижнього краю, коли рядки все ж не вмістилися:
       інакше останній обрізається посередині тексту й читається
       як помилка відображення, а не як «список продовжується». */
    mask-image: linear-gradient(to bottom, #000 calc(100% - 1.5rem), transparent 100%);
    -webkit-mask-image: linear-gradient(to bottom, #000 calc(100% - 1.5rem), transparent 100%);
}

/* На десктопі обмеження не потрібне: вертикального місця вдосталь,
   а обрізаний рядок виглядає як дефект верстки. Показуємо весь список. */
@media (min-width: 1024px) {
    .rc-checkout-items {
        max-height: none;
        overflow-y: visible;
        mask-image: none;
        -webkit-mask-image: none;
    }
}


/* ── Панель кошика ─────────────────────────────────────────────────── */

.rc-cart {
    display: flex;
    flex-direction: column;
    /* flex + min-height: 0 — щоб усередині обмеженого по висоті контейнера
       стискався саме список позицій, а не «виїжджав» підвал із кнопкою */
    flex: 1 1 auto;
    height: 100%;
    min-height: 0;
}

.rc-cart__list {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
}

.rc-cart__footer {
    flex: none;
    padding: var(--rc-space-4);
    /* На телефоні кошик відкривається панеллю на весь екран, і його підвал
       упирається в нижній край. Без відступу на safe-area кнопка «Перейти
       до оплати» частково ховається під жестовою смугою iPhone — на
       десктопі --rc-safe-bottom дорівнює 0, тож правило там ні на що не
       впливає. */
    padding-bottom: calc(var(--rc-space-4) + var(--rc-safe-bottom));
    border-top: 1px solid var(--rc-border);
    background: var(--rc-surface);
}

.rc-cart__total {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: var(--rc-space-3);
    margin-bottom: var(--rc-space-3);
}

.rc-cart__total-label {
    color: var(--rc-text-muted);
    font-size: 0.875rem;
}

.rc-cart__total-value {
    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: -0.02em;
    font-variant-numeric: tabular-nums;
}

/* Десктопна колонка кошика «прилипає» до екрана */
.rc-cart-column {
    display: none;
}

@media (min-width: 1024px) {
    .rc-sale-layout {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 22rem;
        gap: var(--rc-space-4);
        align-items: start;
    }

    .rc-sale-layout > * {
        min-width: 0;
    }

    .rc-cart-column {
        /* Над колонкою кошика стоїть липка панель каталогу, тому відлік
           ведемо від її низу, а не від низу шапки: інакше картка кошика
           і прилипала під панель, і виростала нижче екрана — підвал із
           кнопкою «Перейти до оплати» опинявся за межами вікна, щойно
           позицій ставало більше шести. Висоту панелі беремо з запасом. */
        --rc-cart-top: calc(
            var(--rc-header-h) + var(--rc-safe-top) + var(--rc-catalog-toolbar-h) + var(--rc-space-3)
        );
        --rc-cart-max-h: calc(100vh - var(--rc-cart-top) - var(--rc-space-4));

        display: block;
        position: sticky;
        top: var(--rc-cart-top);
        max-height: var(--rc-cart-max-h);
    }

    .rc-cart-column .rc-card {
        max-height: var(--rc-cart-max-h);
        display: flex;
        flex-direction: column;
    }

    /* Без цього тіло картки лишалося блоком висотою за вмістом: height: 100%
       у .rc-cart не мав від чого рахуватися, список не прокручувався, а
       overflow: hidden на картці зрізав підвал із кнопкою «Перейти до
       оплати» — вона зникала, щойно позицій ставало більше шести. */
    .rc-cart-column .rc-card__body {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
    }
}

/* ─────────────────────────────────────────────────────────────────────
   Панелі (Sidebar) — форми оплати, вибір клієнта тощо
   ───────────────────────────────────────────────────────────────────── */

.rc-drawer.p-sidebar {
    width: 100%;
    max-width: 30rem;
    /* PrimeReact дає панелі height: 100%, а для position: fixed це висота
       «великого» вікна — без урахування адресного рядка мобільного
       браузера. Тому низ панелі (а з ним і кнопка «Перейти до оплати»)
       опинявся за краєм видимої області, доки користувач не прокрутить
       сторінку й рядок не сховається. 100dvh рахує саме видиму висоту;
       для старих браузерів лишається запасне 100%. */
    height: 100%;
    height: 100dvh;
}

.rc-drawer.p-sidebar .p-sidebar-header {
    padding: var(--rc-space-3) var(--rc-space-4);
    border-bottom: 1px solid var(--rc-border);
}

.rc-drawer.p-sidebar .p-sidebar-content {
    display: flex;
    flex-direction: column;
    padding: 0;
    min-height: 0;
}

.rc-drawer__title {
    font-size: 1rem;
    font-weight: 600;
}

.rc-drawer__body {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: var(--rc-space-4);
}

.rc-drawer__body--flush {
    padding: 0;
}

/* Дії панелі завжди видно внизу, над жестовою смугою */
.rc-drawer__footer {
    flex: none;
    display: flex;
    flex-direction: column;
    gap: var(--rc-space-2);
    padding: var(--rc-space-4);
    padding-bottom: calc(var(--rc-space-4) + var(--rc-safe-bottom));
    border-top: 1px solid var(--rc-border);
    background: var(--rc-surface);
}

/* Повноекранна панель сканера */
.rc-scanner.p-sidebar {
    /* Та сама причина, що й у .rc-drawer: інакше кнопки «Закрити» і
       «Підсвітка» з’їжджають під адресний рядок мобільного браузера */
    height: 100%;
    height: 100dvh;
}

.rc-scanner.p-sidebar .p-sidebar-content {
    padding: 0;
    background: #000;
}

/* Власна шапка панелі світла й перекриває відео — у сканера є своя
   кнопка «Закрити», тож стандартну ховаємо (Esc і далі працює) */
.rc-scanner.p-sidebar .p-sidebar-header {
    display: none;
}

.rc-scanner__stage {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: #000;
}

.rc-scanner__video {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Рамка збігається з ділянкою, яку насправді декодує хук (ROI у
   useBarcodeScanner): 80% ширини кадру на 45% висоти. Якщо міняєте
   ROI — міняйте й ці числа, інакше касир наводитиме не туди. */
.rc-scanner__frame {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /* Висота збігається з ROI.height у useBarcodeScanner.js.
       По ширині рамка майже на весь екран: декодер бачить ще ширше,
       тож код зчитається, навіть якщо трохи виходить за краї. */
    width: 94%;
    height: 40%;
    border: 2px solid rgba(255, 255, 255, 0.9);
    border-radius: var(--rc-radius);
    box-shadow: 0 0 0 100vmax rgba(0, 0, 0, 0.5);
    pointer-events: none;
}

.rc-scanner__hint {
    position: absolute;
    left: var(--rc-space-4);
    right: var(--rc-space-4);
    bottom: calc(5.5rem + var(--rc-safe-bottom));
    text-align: center;
    color: rgba(255, 255, 255, 0.92);
    font-size: 0.9375rem;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
    pointer-events: none;
}

/* Стан замість чорного екрана: вмикаємо камеру / немає дозволу тощо */
.rc-scanner__overlay {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--rc-space-3);
    padding: var(--rc-space-6) var(--rc-space-5);
    text-align: center;
    color: #fff;
    background: rgba(20, 21, 26, 0.92);
}

.rc-scanner__overlay i {
    font-size: 2.5rem;
    color: rgba(255, 255, 255, 0.75);
}

.rc-scanner__overlay p {
    margin: 0;
    max-width: 22rem;
}

.rc-scanner__overlay-title {
    font-size: 1.125rem;
    font-weight: 600;
}

.rc-scanner__overlay-text {
    color: rgba(255, 255, 255, 0.75);
    font-size: 0.9375rem;
    line-height: 1.5;
}

.rc-scanner__actions {
    position: absolute;
    left: 0;
    right: 0;
    bottom: calc(var(--rc-space-4) + var(--rc-safe-bottom));
    display: flex;
    justify-content: center;
    gap: var(--rc-space-3);
    padding: 0 var(--rc-space-4);
}

/* ── Рядок «валюта + сума» у формах оплати ─────────────────────────── */

.rc-payment-row {
    padding: var(--rc-space-3) 0;
    border-top: 1px solid var(--rc-border);
}

.rc-payment-row:first-child {
    border-top: 0;
    padding-top: 0;
}

.rc-payment-row__top {
    display: flex;
    align-items: center;
    gap: var(--rc-space-2);
}

.rc-payment-row__amount {
    flex: 1 1 auto;
    min-width: 0;
}

.rc-payment-row__currency {
    flex: none;
    width: 6.25rem;
}

.rc-payment-row__method {
    margin-top: var(--rc-space-2);
}

.rc-payment-row .p-dropdown,
.rc-payment-row .p-inputnumber,
.rc-payment-row .p-inputtext {
    width: 100%;
}

.rc-field-error {
    display: block;
    margin-top: var(--rc-space-1);
    color: var(--rc-outcome-strong);
    font-size: 0.8125rem;
}

.rc-field-hint {
    display: block;
    margin-top: var(--rc-space-1);
    color: var(--rc-text-muted);
    font-size: 0.8125rem;
}

.rc-field {
    margin-bottom: var(--rc-space-4);
}

.rc-field__label {
    display: block;
    margin-bottom: var(--rc-space-2);
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--rc-text);
}

.rc-field .p-inputtext,
.rc-field .p-dropdown,
.rc-field .p-calendar,
.rc-field .p-password,
/* Password із toggleMask загортає інпут ще в один div.p-icon-field —
   без нього поле пароля виходило вужчим за поле логіна на ширину іконки */
.rc-field .p-password .p-icon-field,
.rc-field .p-password .p-inputtext {
    width: 100%;
}

/* ─────────────────────────────────────────────────────────────────────
   Порожні стани, завантаження
   ───────────────────────────────────────────────────────────────────── */

.rc-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--rc-space-2);
    padding: var(--rc-space-6) var(--rc-space-4);
    text-align: center;
    color: var(--rc-text-muted);
}

.rc-empty__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 50%;
    background: var(--rc-surface-sunken);
    color: var(--rc-text-subtle);
    font-size: 1.5rem;
}

.rc-empty__title {
    font-weight: 600;
    color: var(--rc-text);
}

.rc-empty__text {
    font-size: 0.875rem;
    max-width: 22rem;
}

/* ─────────────────────────────────────────────────────────────────────
   Двоколонковий макет «список + деталі»
   ───────────────────────────────────────────────────────────────────── */

.rc-split {
    display: grid;
    grid-template-columns: 1fr;
    gap: var(--rc-space-4);
    align-items: start;
}

.rc-split > * {
    min-width: 0;
}

@media (min-width: 1024px) {
    .rc-split {
        grid-template-columns: minmax(0, 24rem) minmax(0, 1fr);
    }

    .rc-split__aside {
        position: sticky;
        top: calc(var(--rc-header-h) + var(--rc-safe-top) + var(--rc-space-4));
    }
}

/* На вузьких екранах деталі відкриваються панеллю, а не другою колонкою */
.rc-split__detail--mobile-hidden {
    display: none;
}

@media (min-width: 1024px) {
    .rc-split__detail--mobile-hidden {
        display: block;
    }
}

/* ── Рядок списку, по якому можна тапнути ──────────────────────────── */

.rc-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.rc-list-item {
    display: flex;
    align-items: center;
    gap: var(--rc-space-3);
    width: 100%;
    min-height: var(--rc-touch-target);
    padding: var(--rc-space-3) var(--rc-space-4);
    border: 0;
    border-top: 1px solid var(--rc-border);
    background: none;
    color: inherit;
    font-family: inherit;
    text-align: left;
    cursor: pointer;
    transition: background 0.15s;
}

.rc-list > .rc-list-item:first-child,
.rc-list > li:first-child .rc-list-item {
    border-top: 0;
}

.rc-list-item:hover {
    background: var(--rc-surface-sunken);
}

.rc-list-item--active {
    background: var(--rc-outcome-soft);
}

.rc-list-item--active:hover {
    background: var(--rc-outcome-soft);
}

.rc-list-item__main {
    flex: 1 1 auto;
    min-width: 0;
}

.rc-list-item__title {
    font-weight: 600;
    font-size: 0.9375rem;
    overflow: hidden;
    text-overflow: ellipsis;
}

.rc-list-item__meta {
    display: flex;
    align-items: center;
    gap: var(--rc-space-2);
    margin-top: 0.125rem;
    min-width: 0;
    font-size: 0.8125rem;
    color: var(--rc-text-muted);
}

.rc-list-item__meta > span,
.rc-line-item__meta > span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.rc-list-item__meta > i,
.rc-line-item__meta > i {
    flex: none;
}

.rc-list-item__side {
    flex: none;
    display: flex;
    align-items: center;
    gap: var(--rc-space-2);
    text-align: right;
}

.rc-list-pager {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--rc-space-3);
    padding: var(--rc-space-3) var(--rc-space-4);
    border-top: 1px solid var(--rc-border);
    font-size: 0.8125rem;
    color: var(--rc-text-muted);
}

/* ─────────────────────────────────────────────────────────────────────
   Екран входу
   ───────────────────────────────────────────────────────────────────── */

.rc-login {
    display: grid;
    grid-template-columns: 1fr;
    min-height: 100vh;
    min-height: 100dvh;
    background: var(--rc-brand-black);
}

@media (min-width: 900px) {
    .rc-login {
        grid-template-columns: minmax(24rem, 32rem) 1fr;
    }
}

.rc-login__panel {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: var(--rc-space-6) var(--rc-space-4);
    padding-top: calc(var(--rc-space-6) + var(--rc-safe-top));
    padding-bottom: calc(var(--rc-space-6) + var(--rc-safe-bottom));
}

.rc-login__card {
    width: 100%;
    max-width: 24rem;
    margin: 0 auto;
    padding: var(--rc-space-5);
    border-radius: var(--rc-radius-lg);
    background: var(--rc-surface);
    box-shadow: var(--rc-shadow-lg);
}

.rc-login__brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--rc-space-2);
    margin-bottom: var(--rc-space-5);
    text-align: center;
}

.rc-login__logo {
    width: 3.5rem;
    height: 3.5rem;
    object-fit: contain;
}

.rc-login__wordmark {
    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: -0.02em;
}

.rc-login__wordmark em {
    font-style: normal;
    color: var(--rc-brand-red);
}

.rc-login__hint {
    font-size: 0.875rem;
    color: var(--rc-text-muted);
}

.rc-login__footer {
    margin-top: var(--rc-space-5);
    text-align: center;
    font-size: 0.75rem;
    color: var(--rc-text-subtle);
}

.rc-login__art {
    display: none;
    background-size: cover;
    background-position: center;
    position: relative;
}

@media (min-width: 900px) {
    .rc-login__art {
        display: block;
    }
}

.rc-login__art::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, rgba(20, 21, 26, 0.55) 0%, rgba(20, 21, 26, 0) 45%);
}

/* ─────────────────────────────────────────────────────────────────────
   Точкові налаштування компонентів PrimeReact
   ───────────────────────────────────────────────────────────────────── */

/* Мінімальні сенсорні цілі для полів і кнопок */
.p-button {
    min-height: var(--rc-touch-target);
    border-radius: var(--rc-radius-sm);
    font-weight: 600;
}

.p-button.p-button-sm {
    min-height: 2.25rem;
}

.p-button.p-button-icon-only.p-button-rounded {
    border-radius: 50%;
}

.p-inputtext,
.p-dropdown,
.p-calendar .p-inputtext {
    min-height: var(--rc-touch-target);
    border-radius: var(--rc-radius-sm);
    /* 16px не дає iOS Safari зумити сторінку під час фокусу на полі */
    font-size: 1rem;
}

.p-inputnumber-input {
    text-align: right;
}

.p-dropdown .p-dropdown-label {
    display: flex;
    align-items: center;
}

/* Toast над нижньою навігацією */
.p-toast {
    max-width: calc(100vw - 2 * var(--rc-space-3));
}

/* Модальні вікна на мобільному займають усю ширину */
.p-dialog {
    width: calc(100vw - 2 * var(--rc-space-4));
    max-width: 28rem;
    border-radius: var(--rc-radius);
}

.p-dialog .p-dialog-content:last-of-type {
    border-radius: 0 0 var(--rc-radius) var(--rc-radius);
}

/* Повідомлення (Message) на всю ширину панелі */
.rc-message.p-message {
    width: 100%;
    margin: 0 0 var(--rc-space-3);
    border-radius: var(--rc-radius-sm);
}

.rc-message.p-message .p-message-wrapper {
    padding: var(--rc-space-3);
}

/* Таби історії — рівномірні, з великими цілями */
.rc-tabs .p-tabview-nav {
    border-radius: var(--rc-radius) var(--rc-radius) 0 0;
}

.rc-tabs .p-tabview-nav li {
    flex: 1 1;
}

.rc-tabs .p-tabview-nav li .p-tabview-nav-link {
    justify-content: center;
    min-height: var(--rc-touch-target);
    padding: var(--rc-space-3);
}

.rc-tabs .p-tabview-panels {
    padding: 0;
    border-radius: 0 0 var(--rc-radius) var(--rc-radius);
}

/* Прибираємо анімацію для тих, хто її не переносить */
@media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
        scroll-behavior: auto !important;
    }
}

/* Друк: лишаємо тільки вміст */
@media print {
    .rc-header,
    .rc-bottom-nav,
    .rc-catalog-toolbar {
        display: none !important;
    }

    .rc-main {
        padding: 0;
        max-width: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/theme/app.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;;AAEF;;0EAE0E;;AAE1E;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,+CAA+C;IAC/C,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,wBAAwB;IACxB,qBAAqB;IACrB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,kCAAkC;IAClC,oDAAoD;IACpD,wCAAwC;AAC5C;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA,qEAAqE;AACrE;;;;;IAKI,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;0EAE0E;;AAE1E;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gCAAgC;IAChC,cAAc;IACd,4CAA4C;IAC5C,2DAA2D;IAC3D,wFAAwF;AAC5F;;AAEA;IACI,gBAAgB;AACpB;;AAEA;mDACmD;AACnD;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,4CAA4C;QAC5C,wFAAwF;IAC5F;AACJ;;AAEA;IACI,iEAAiE;IACjE;QACI,iCAAiC;IACrC;AACJ;;AAEA,0EAA0E;;AAE1E;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,qDAAqD;IACrD,+CAA+C;IAC/C,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;AACd;;AAEA,0BAA0B;AAC1B;;IAEI,gCAAgC;IAChC,sCAAsC;IACtC,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;;IAEI,oCAAoC;IACpC,WAAW;IACX,uCAAuC;AAC3C;;AAEA,yEAAyE;;AAEzE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA,wDAAwD;AACxD;IACI,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA,yEAAyE;;AAEzE;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,aAAa;IACb,oBAAoB;IACpB,4DAA4D;IAC5D,qCAAqC;IACrC,6BAA6B;IAC7B,sCAAsC;IACtC,6CAA6C;AACjD;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,SAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;IAChB,4BAA4B;IAC5B,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;IACpC,+BAA+B;IAC/B,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA,yEAAyE;;AAEzE;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,sCAAsC;AAC1C;;AAEA;IACI,8DAA8D;IAC9D,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,kCAAkC;IAClC,4CAA4C;IAC5C,SAAS;IACT,kCAAkC;IAClC,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;0EAE0E;;AAE1E;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,+BAA+B;IAC/B,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,4CAA4C;IAC5C,yCAAyC;AAC7C;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA,0EAA0E;;AAE1E;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,4CAA4C;IAC5C,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yEAAyE;;AAEzE;IACI,aAAa;IACb,4DAA4D;IAC5D,sBAAsB;AAC1B;;AAEA;IACI,4CAA4C;IAC5C,kCAAkC;IAClC,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA,yEAAyE;;AAEzE;IACI,aAAa;IACb,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,4CAA4C;IAC5C,kCAAkC;IAClC,+BAA+B;IAC/B,6BAA6B;IAC7B,+BAA+B;IAC/B,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iEAAiE;AACrE;;AAEA;IACI,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,UAAU;IACV,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;AACnC;;AAEA;IACI,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA;IACI,iCAAiC;IACjC,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,WAAW;AACf;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;0EAE0E;;AAE1E;IACI,gBAAgB;IAChB,kDAAkD;IAClD,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,4CAA4C;IAC5C,qCAAqC;IACrC,kCAA0B;YAA1B,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;wEACwE;AACxE;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,SAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI;QACI,cAAc;QACd,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,WAAW;QACX,sBAAsB;IAC1B;;IAEA;kDAC8C;IAC9C;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;;mEAE+D;IAC/D;;;QAGI,kCAAkC;QAClC,sBAAsB;IAC1B;;IAEA;kEAC8D;IAC9D;QACI,eAAe;IACnB;AACJ;;AAEA;kEACkE;AAClE;IACI,UAAU;IACV,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,oCAAoC;IACpC,6BAA6B;IAC7B,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb;sEACkE;IAClE,6DAA6D;IAC7D,sBAAsB;AAC1B;;AAEA;4DAC4D;AAC5D;IACI;QACI,4DAA4D;QAC5D,sBAAsB;IAC1B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB;qCACiC;IACjC,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,kCAAkC;IAClC,+BAA+B;IAC/B,6BAA6B;IAC7B,+BAA+B;IAC/B,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,iEAAiE;AACrE;;AAEA;IACI,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gCAAgC;IAChC,kCAAkC;IAClC,0CAA0C;IAC1C,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA,gEAAgE;AAChE;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iEAAiE;IACjE,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,qDAAqD;AACrD;IACI,uBAAuB;IACvB;6DACyD;IACzD,2BAA2B;IAC3B,wFAAwF;AAC5F;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;;gEAEgE;AAChE;IACI;QACI,mBAAmB;QACnB,0BAA0B;IAC9B;;IAEA;QACI,YAAY;QACZ,gCAAgC;IACpC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;wEACoE;IACpE;QACI,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;iEAEiE;AACjE;IACI;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,gBAAgB;QAChB,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA,yEAAyE;;AAEzE;IACI,aAAa;IACb,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,kCAAkC;IAClC,kCAAkC;IAClC,6BAA6B;IAC7B,+BAA+B;IAC/B,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,kCAAkC;IAClC,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;;0EAE0E;;AAE1E;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,4CAA4C;IAC5C,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,YAAY;IACZ,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;AACd;;AAEA,iDAAiD;AACjD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,kCAAkC;IAClC,oCAAoC;IACpC,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;;uDAEuD;AACvD;IACI;;gEAE4D;IAC5D,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB;;iEAE6D;IAC7D,kFAAkF;IAClF,0FAA0F;AAC9F;;AAEA;yEACyE;AACzE;IACI;QACI,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;QAChB,wBAAwB;IAC5B;AACJ;;;AAGA,yEAAyE;;AAEzE;IACI,aAAa;IACb,sBAAsB;IACtB;yEACqE;IACrE,cAAc;IACd,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B;;;;iBAIa;IACb,+DAA+D;IAC/D,sCAAsC;IACtC,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA,kDAAkD;AAClD;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;QACb,2CAA2C;QAC3C,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI;;;;0EAIkE;QAClE;;SAEC;QACD,qEAAqE;;QAErE,cAAc;QACd,gBAAgB;QAChB,uBAAuB;QACvB,gCAAgC;IACpC;;IAEA;QACI,gCAAgC;QAChC,aAAa;QACb,sBAAsB;IAC1B;;IAEA;;;oEAGgE;IAChE;QACI,aAAa;QACb,sBAAsB;QACtB,cAAc;QACd,aAAa;IACjB;AACJ;;AAEA;;0EAE0E;;AAE1E;IACI,WAAW;IACX,gBAAgB;IAChB;;;;;qDAKiD;IACjD,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,4CAA4C;IAC5C,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA,uDAAuD;AACvD;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,0BAA0B;IAC1B,+DAA+D;IAC/D,sCAAsC;IACtC,6BAA6B;AACjC;;AAEA,gCAAgC;AAChC;IACI;sEACkE;IAClE,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;iEACiE;AACjE;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;+DAE+D;AAC/D;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC;;gEAE4D;IAC5D,UAAU;IACV,WAAW;IACX,0CAA0C;IAC1C,+BAA+B;IAC/B,4CAA4C;IAC5C,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,4CAA4C;IAC5C,kBAAkB;IAClB,gCAAgC;IAChC,oBAAoB;IACpB,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA,sEAAsE;AACtE;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,4CAA4C;IAC5C,kBAAkB;IAClB,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,uDAAuD;IACvD,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA,yEAAyE;;AAEzE;IACI,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;;IAGI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,+BAA+B;IAC/B,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;;;;;;;;IAQI,WAAW;AACf;;AAEA;;0EAE0E;;AAE1E;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,4CAA4C;IAC5C,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,oCAAoC;IACpC,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;0EAE0E;;AAE1E;IACI,aAAa;IACb,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,sDAAsD;IAC1D;;IAEA;QACI,gBAAgB;QAChB,sEAAsE;IAC1E;AACJ;;AAEA,0EAA0E;AAC1E;IACI,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA,yEAAyE;;AAEzE;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,kCAAkC;IAClC,4CAA4C;IAC5C,SAAS;IACT,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;AAChC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,4CAA4C;IAC5C,sCAAsC;IACtC,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;;0EAE0E;;AAE1E;IACI,aAAa;IACb,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI;QACI,+CAA+C;IACnD;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,4CAA4C;IAC5C,yDAAyD;IACzD,+DAA+D;AACnE;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,0BAA0B;IAC1B,kCAAkC;IAClC,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,sFAAsF;AAC1F;;AAEA;;0EAE0E;;AAE1E,gDAAgD;AAChD;IACI,kCAAkC;IAClC,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,kCAAkC;IAClC,kCAAkC;IAClC,kEAAkE;IAClE,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,iCAAiC;AACjC;IACI,8CAA8C;AAClD;;AAEA,qDAAqD;AACrD;IACI,0CAA0C;IAC1C,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,oDAAoD;AACxD;;AAEA,gDAAgD;AAChD;IACI,WAAW;IACX,6BAA6B;IAC7B,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,iDAAiD;AACjD;IACI,oDAAoD;AACxD;;AAEA;IACI,SAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,oDAAoD;AACxD;;AAEA,sDAAsD;AACtD;IACI;;;QAGI,qCAAqC;QACrC,uCAAuC;QACvC,sCAAsC;QACtC,gCAAgC;IACpC;AACJ;;AAEA,+BAA+B;AAC/B;IACI;;;QAGI,wBAAwB;IAC5B;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;AACJ","sourcesContent":["/*\n * Базові стилі застосунку RCT Cash.\n *\n * Принципи:\n *  1. Mobile-first — базові правила описують телефон, медіа-запити\n *     розширюють макет для планшета й десктопа.\n *  2. Жодних !important-хаків поверх PrimeReact: фірмові кольори\n *     вшиті в саму тему (scripts/build-theme.js).\n *  3. Всі значення — з src/theme/tokens.css.\n */\n\n/* ─────────────────────────────────────────────────────────────────────\n   Скидання й типографіка\n   ───────────────────────────────────────────────────────────────────── */\n\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n\nhtml {\n    /* Не даємо iOS збільшувати шрифт у ландшафті */\n    -webkit-text-size-adjust: 100%;\n}\n\nbody {\n    margin: 0;\n    min-height: 100vh;\n    background: var(--rc-bg);\n    color: var(--rc-text);\n    font-family: var(--rc-font);\n    font-size: 15px;\n    line-height: 1.5;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    /* Прибирає сіру підсвітку при тапі на Android/iOS */\n    -webkit-tap-highlight-color: transparent;\n}\n\n.p-component,\n.p-inputtext {\n    font-family: var(--rc-font);\n}\n\n/* Суми завжди моноширинними цифрами — колонки чисел не «стрибають» */\n.rc-money,\n.rc-summary-row__value,\n.rc-stat__value,\n.p-inputnumber-input,\n.rc-catalog-tile__price {\n    font-variant-numeric: tabular-nums;\n    font-feature-settings: 'tnum';\n}\n\n.rc-money {\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.rc-money--income {\n    color: var(--rc-income-strong);\n}\n\n.rc-money--outcome {\n    color: var(--rc-outcome-strong);\n}\n\n/* ─────────────────────────────────────────────────────────────────────\n   Каркас застосунку\n   ───────────────────────────────────────────────────────────────────── */\n\n.rc-shell {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    min-height: 100dvh;\n}\n\n.rc-main {\n    flex: 1 1 auto;\n    width: 100%;\n    max-width: var(--rc-content-max);\n    margin: 0 auto;\n    padding: var(--rc-space-4) var(--rc-space-3);\n    /* Знизу лишаємо місце під таб-бар і жестову смугу iPhone */\n    padding-bottom: calc(var(--rc-bottom-nav-h) + var(--rc-safe-bottom) + var(--rc-space-4));\n}\n\n.rc-main--wide {\n    max-width: 96rem;\n}\n\n/* Вузька колонка всередині широкого контейнера — для підсумків,\n   форм і всього, що погано читається розтягнутим */\n.rc-narrow {\n    width: 100%;\n    max-width: 40rem;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n@media (min-width: 768px) {\n    .rc-main {\n        padding: var(--rc-space-5) var(--rc-space-4);\n        padding-bottom: calc(var(--rc-bottom-nav-h) + var(--rc-safe-bottom) + var(--rc-space-5));\n    }\n}\n\n@media (min-width: 1024px) {\n    /* На десктопі нижньої навігації немає — забираємо резерв місця */\n    .rc-main {\n        padding-bottom: var(--rc-space-6);\n    }\n}\n\n/* ── Верхня панель ──────────────────────────────────────────────────── */\n\n.rc-header {\n    position: sticky;\n    top: 0;\n    z-index: 1000;\n    display: flex;\n    align-items: center;\n    gap: var(--rc-space-3);\n    height: calc(var(--rc-header-h) + var(--rc-safe-top));\n    padding: var(--rc-safe-top) var(--rc-space-3) 0;\n    background: var(--rc-brand-black);\n    color: #fff;\n}\n\n.rc-header__brand {\n    display: flex;\n    align-items: center;\n    gap: var(--rc-space-2);\n    min-width: 0;\n    text-decoration: none;\n    color: inherit;\n    background: none;\n    border: 0;\n    padding: 0;\n    cursor: pointer;\n}\n\n.rc-header__logo {\n    width: 1.75rem;\n    height: 1.75rem;\n    flex: none;\n    object-fit: contain;\n}\n\n.rc-header__wordmark {\n    font-size: 1.0625rem;\n    font-weight: 700;\n    letter-spacing: -0.01em;\n    white-space: nowrap;\n}\n\n.rc-header__wordmark em {\n    font-style: normal;\n    color: var(--rc-brand-red);\n}\n\n.rc-header__context {\n    display: none;\n    min-width: 0;\n    flex: 1 1 auto;\n    align-items: center;\n    gap: var(--rc-space-2);\n}\n\n@media (min-width: 640px) {\n    .rc-header__context {\n        display: flex;\n    }\n}\n\n.rc-header__division {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 0.8125rem;\n    color: rgba(255, 255, 255, 0.65);\n}\n\n.rc-header__spacer {\n    flex: 1 1 auto;\n}\n\n.rc-header__actions {\n    display: flex;\n    align-items: center;\n    gap: var(--rc-space-1);\n    flex: none;\n}\n\n/* Кнопки в темній шапці */\n.rc-header .p-button.p-button-text,\n.rc-header .p-button.p-button-outlined {\n    color: rgba(255, 255, 255, 0.85);\n    border-color: rgba(255, 255, 255, 0.2);\n    min-width: var(--rc-touch-target);\n    height: var(--rc-touch-target);\n}\n\n.rc-header .p-button.p-button-text:enabled:hover,\n.rc-header .p-button.p-button-outlined:enabled:hover {\n    background: rgba(255, 255, 255, 0.1);\n    color: #fff;\n    border-color: rgba(255, 255, 255, 0.35);\n}\n\n/* ── Індикатор стану зміни ─────────────────────────────────────────── */\n\n.rc-shift-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.375rem;\n    padding: 0.25rem 0.625rem;\n    border-radius: var(--rc-radius-pill);\n    font-size: 0.75rem;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.rc-shift-badge__dot {\n    width: 0.5rem;\n    height: 0.5rem;\n    border-radius: 50%;\n    background: currentColor;\n    flex: none;\n}\n\n.rc-shift-badge--open {\n    background: rgba(22, 163, 74, 0.16);\n    color: #4ade80;\n}\n\n.rc-shift-badge--closed {\n    background: rgba(255, 255, 255, 0.12);\n    color: rgba(255, 255, 255, 0.7);\n}\n\n/* Той самий бейдж на світлому фоні (усередині карток) */\n.rc-shift-badge--on-light.rc-shift-badge--open {\n    background: var(--rc-income-soft);\n    color: var(--rc-income-strong);\n}\n\n.rc-shift-badge--on-light.rc-shift-badge--closed {\n    background: var(--rc-neutral-soft);\n    color: var(--rc-neutral);\n}\n\n/* ── Нижня навігація (телефон і планшет) ───────────────────────────── */\n\n.rc-bottom-nav {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000;\n    display: flex;\n    align-items: stretch;\n    height: calc(var(--rc-bottom-nav-h) + var(--rc-safe-bottom));\n    padding-bottom: var(--rc-safe-bottom);\n    background: var(--rc-surface);\n    border-top: 1px solid var(--rc-border);\n    box-shadow: 0 -1px 3px rgba(20, 21, 26, 0.05);\n}\n\n@media (min-width: 1024px) {\n    .rc-bottom-nav {\n        display: none;\n    }\n}\n\n.rc-bottom-nav__item {\n    flex: 1 1 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.1875rem;\n    padding: var(--rc-space-1);\n    border: 0;\n    background: none;\n    color: var(--rc-text-subtle);\n    font-family: inherit;\n    font-size: 0.6875rem;\n    font-weight: 500;\n    line-height: 1.2;\n    cursor: pointer;\n    position: relative;\n    transition: color 0.15s;\n}\n\n.rc-bottom-nav__item i {\n    font-size: 1.25rem;\n}\n\n.rc-bottom-nav__item:hover {\n    color: var(--rc-text-muted);\n}\n\n.rc-bottom-nav__item--active {\n    color: var(--rc-brand-red);\n}\n\n.rc-bottom-nav__item--active::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 2rem;\n    height: 3px;\n    border-radius: 0 0 3px 3px;\n    background: var(--rc-brand-red);\n}\n\n.rc-bottom-nav__badge {\n    position: absolute;\n    top: 0.375rem;\n    left: 50%;\n    margin-left: 0.375rem;\n    min-width: 1.125rem;\n    height: 1.125rem;\n    padding: 0 0.25rem;\n    border-radius: var(--rc-radius-pill);\n    background: var(--rc-brand-red);\n    color: #fff;\n    font-size: 0.625rem;\n    font-weight: 700;\n    line-height: 1.125rem;\n    text-align: center;\n}\n\n/* ── Бічне меню (десктоп + «Ще» на мобільному) ─────────────────────── */\n\n.rc-menu-panel {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.rc-menu-panel__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: var(--rc-space-3);\n    padding: var(--rc-space-4);\n    border-bottom: 1px solid var(--rc-border);\n}\n\n.rc-menu-panel__body {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    padding: var(--rc-space-3);\n}\n\n.rc-menu-panel__footer {\n    padding: var(--rc-space-4);\n    border-top: 1px solid var(--rc-border);\n}\n\n.rc-menu-section-title {\n    padding: var(--rc-space-3) var(--rc-space-2) var(--rc-space-2);\n    font-size: 0.6875rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: var(--rc-text-subtle);\n}\n\n.rc-menu-item {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    gap: var(--rc-space-3);\n    min-height: var(--rc-touch-target);\n    padding: var(--rc-space-2) var(--rc-space-3);\n    border: 0;\n    border-radius: var(--rc-radius-sm);\n    background: none;\n    color: var(--rc-text);\n    font-family: inherit;\n    font-size: 0.9375rem;\n    text-align: left;\n    cursor: pointer;\n    transition: background 0.15s;\n}\n\n.rc-menu-item:hover {\n    background: var(--rc-neutral-soft);\n}\n\n.rc-menu-item i {\n    font-size: 1.125rem;\n    color: var(--rc-text-muted);\n    flex: none;\n}\n\n.rc-menu-item__label {\n    flex: 1 1 auto;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.rc-menu-item--active {\n    background: var(--rc-outcome-soft);\n    color: var(--rc-brand-red-dark);\n    font-weight: 600;\n}\n\n.rc-menu-item--active i {\n    color: var(--rc-brand-red);\n}\n\n.rc-menu-user {\n    display: flex;\n    align-items: center;\n    gap: var(--rc-space-3);\n    min-width: 0;\n}\n\n.rc-menu-user__name {\n    display: block;\n    font-weight: 600;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.rc-menu-user__meta {\n    display: block;\n    font-size: 0.8125rem;\n    color: var(--rc-text-muted);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* ─────────────────────────────────────────────────────────────────────\n   Картки й типові блоки\n   ───────────────────────────────────────────────────────────────────── */\n\n.rc-stack {\n    display: flex;\n    flex-direction: column;\n    gap: var(--rc-space-4);\n}\n\n.rc-stack--tight {\n    gap: var(--rc-space-2);\n}\n\n.rc-card {\n    background: var(--rc-surface);\n    border: 1px solid var(--rc-border);\n    border-radius: var(--rc-radius);\n    box-shadow: var(--rc-shadow-sm);\n    overflow: hidden;\n}\n\n.rc-card__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: var(--rc-space-3);\n    padding: var(--rc-space-3) var(--rc-space-4);\n    border-bottom: 1px solid var(--rc-border);\n}\n\n.rc-card__title {\n    margin: 0;\n    font-size: 0.9375rem;\n    font-weight: 600;\n    color: var(--rc-text);\n}\n\n.rc-card__subtitle {\n    margin: 0.125rem 0 0;\n    font-size: 0.8125rem;\n    font-weight: 400;\n    color: var(--rc-text-muted);\n}\n\n.rc-card__body {\n    padding: var(--rc-space-4);\n}\n\n.rc-card__body--flush {\n    padding: 0;\n}\n\n.rc-page-title {\n    margin: 0 0 var(--rc-space-1);\n    font-size: 1.375rem;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n}\n\n.rc-page-subtitle {\n    margin: 0;\n    color: var(--rc-text-muted);\n    font-size: 0.875rem;\n}\n\n/* ── Списки сум ─────────────────────────────────────────────────────── */\n\n.rc-summary-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.rc-summary-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: var(--rc-space-3);\n    padding: var(--rc-space-3) var(--rc-space-4);\n    border-top: 1px solid var(--rc-border);\n}\n\n.rc-summary-row:first-child {\n    border-top: 0;\n}\n\n.rc-summary-row__label {\n    color: var(--rc-text-muted);\n    font-size: 0.875rem;\n    min-width: 0;\n}\n\n.rc-summary-row__sub {\n    display: block;\n    font-size: 0.75rem;\n    color: var(--rc-text-subtle);\n}\n\n.rc-summary-row__value {\n    font-weight: 600;\n    text-align: right;\n    white-space: nowrap;\n}\n\n.rc-summary-row__value--stack {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.125rem;\n}\n\n.rc-summary-row--total {\n    background: var(--rc-surface-sunken);\n}\n\n.rc-summary-row--total .rc-summary-row__label {\n    color: var(--rc-text);\n    font-weight: 600;\n}\n\n.rc-summary-row--total .rc-summary-row__value {\n    font-size: 1.125rem;\n}\n\n/* ── Плитки-показники ──────────────────────────────────────────────── */\n\n.rc-stat-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(8.5rem, 1fr));\n    gap: var(--rc-space-3);\n}\n\n.rc-stat {\n    padding: var(--rc-space-3) var(--rc-space-4);\n    border: 1px solid var(--rc-border);\n    border-radius: var(--rc-radius);\n    background: var(--rc-surface);\n}\n\n.rc-stat__label {\n    display: flex;\n    align-items: center;\n    gap: var(--rc-space-2);\n    font-size: 0.75rem;\n    font-weight: 600;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    color: var(--rc-text-subtle);\n}\n\n.rc-stat__value {\n    margin-top: var(--rc-space-1);\n    font-size: 1.375rem;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n}\n\n.rc-stat__value--sm {\n    font-size: 1.0625rem;\n}\n\n/* ── Головні дії (екран зміни) ─────────────────────────────────────── */\n\n.rc-action-grid {\n    display: grid;\n    gap: var(--rc-space-3);\n    grid-template-columns: 1fr;\n}\n\n@media (min-width: 600px) {\n    .rc-action-grid--split {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n.rc-action {\n    display: flex;\n    align-items: center;\n    gap: var(--rc-space-3);\n    width: 100%;\n    min-height: 4.25rem;\n    padding: var(--rc-space-3) var(--rc-space-4);\n    border: 1px solid var(--rc-border);\n    border-radius: var(--rc-radius);\n    background: var(--rc-surface);\n    box-shadow: var(--rc-shadow-sm);\n    color: var(--rc-text);\n    font-family: inherit;\n    font-size: 1rem;\n    text-align: left;\n    cursor: pointer;\n    transition: transform 0.12s, box-shadow 0.15s, border-color 0.15s;\n}\n\n.rc-action:hover {\n    box-shadow: var(--rc-shadow);\n    border-color: var(--rc-border-strong);\n}\n\n.rc-action:active {\n    transform: scale(0.99);\n}\n\n.rc-action:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n.rc-action__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 2.75rem;\n    height: 2.75rem;\n    flex: none;\n    border-radius: var(--rc-radius-sm);\n    font-size: 1.25rem;\n}\n\n.rc-action__text {\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n.rc-action__title {\n    font-weight: 600;\n    display: block;\n}\n\n.rc-action__hint {\n    display: block;\n    font-size: 0.8125rem;\n    color: var(--rc-text-muted);\n}\n\n.rc-action__chevron {\n    color: var(--rc-text-subtle);\n    flex: none;\n}\n\n.rc-action--income .rc-action__icon {\n    background: var(--rc-income-soft);\n    color: var(--rc-income-strong);\n}\n\n.rc-action--outcome .rc-action__icon {\n    background: var(--rc-outcome-soft);\n    color: var(--rc-outcome-strong);\n}\n\n.rc-action--neutral .rc-action__icon {\n    background: var(--rc-neutral-soft);\n    color: var(--rc-neutral);\n}\n\n.rc-action--primary {\n    background: var(--rc-brand-black);\n    border-color: var(--rc-brand-black);\n    color: #fff;\n}\n\n.rc-action--primary .rc-action__icon {\n    background: rgba(255, 255, 255, 0.12);\n    color: #fff;\n}\n\n.rc-action--primary .rc-action__hint,\n.rc-action--primary .rc-action__chevron {\n    color: rgba(255, 255, 255, 0.7);\n}\n\n/* ─────────────────────────────────────────────────────────────────────\n   Каталог товарів (екран продажу)\n   ───────────────────────────────────────────────────────────────────── */\n\n.rc-catalog-toolbar {\n    position: sticky;\n    top: calc(var(--rc-header-h) + var(--rc-safe-top));\n    z-index: 900;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: var(--rc-space-2);\n    padding: var(--rc-space-2) var(--rc-space-3);\n    background: rgba(244, 245, 247, 0.92);\n    backdrop-filter: blur(8px);\n    border-bottom: 1px solid var(--rc-border);\n}\n\n.rc-catalog-toolbar .p-inputtext {\n    width: 100%;\n}\n\n.rc-catalog-toolbar__search {\n    flex: 1 1 8rem;\n    min-width: 0;\n}\n\n/* Перемикач «Товари / Послуги»: на телефоні — окремим рядком на всю\n   ширину, з рівними половинами; від 600px стає в один ряд із пошуком. */\n.rc-catalog-toolbar__kind {\n    flex: 1 1 100%;\n    order: -1;\n}\n\n.rc-catalog-toolbar__kind .p-selectbutton {\n    display: flex;\n    width: 100%;\n}\n\n.rc-catalog-toolbar__kind .p-selectbutton .p-button {\n    flex: 1 1 0;\n    justify-content: center;\n    white-space: nowrap;\n    padding-left: var(--rc-space-4);\n    padding-right: var(--rc-space-4);\n}\n\n@media (min-width: 600px) {\n    .rc-catalog-toolbar__kind {\n        flex: 0 0 auto;\n        order: 0;\n        width: auto;\n    }\n\n    .rc-catalog-toolbar__kind .p-selectbutton {\n        width: auto;\n        gap: var(--rc-space-2);\n    }\n\n    /* Скидаємо мобільне розтягування, інакше підписи кнопок\n       стискаються й накладаються один на одного */\n    .rc-catalog-toolbar__kind .p-selectbutton .p-button {\n        flex: 0 0 auto;\n        min-width: 7.5rem;\n    }\n\n    /* SelectButton за замовчуванням склеює кнопки в одну «таблетку»:\n       у сусідніх кнопок зрізані радіуси й прибрана ліва межа. Оскільки\n       ми рознесли їх проміжком, повертаємо кожній повний вигляд. */\n    .rc-catalog-toolbar__kind .p-selectbutton .p-button,\n    .rc-catalog-toolbar__kind .p-selectbutton .p-button:first-of-type,\n    .rc-catalog-toolbar__kind .p-selectbutton .p-button:last-of-type {\n        border-radius: var(--rc-radius-sm);\n        border-left-width: 1px;\n    }\n\n    /* Пошук не має розтягуватися на весь вільний простір —\n       поруч із ним і так порожньо, а довге поле читається гірше */\n    .rc-catalog-toolbar__search {\n        flex: 0 1 22rem;\n    }\n}\n\n/* min-width, а не width: кнопка з підписом або лічильником має право\n   стати ширшою. З жорсткою шириною кошик обрізав власний бейдж. */\n.rc-catalog-toolbar .p-button {\n    flex: none;\n    min-width: var(--rc-touch-target);\n    height: var(--rc-touch-target);\n}\n\n.rc-breadcrumb {\n    display: flex;\n    align-items: center;\n    gap: var(--rc-space-2);\n    flex-wrap: wrap;\n    padding: var(--rc-space-3) 0 0;\n    font-size: 0.875rem;\n    color: var(--rc-text-muted);\n}\n\n.rc-breadcrumb__chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.375rem;\n    padding: 0.25rem 0.625rem;\n    border-radius: var(--rc-radius-pill);\n    background: var(--rc-surface);\n    border: 1px solid var(--rc-border);\n}\n\n.rc-catalog-grid {\n    display: grid;\n    /* auto-fill + minmax: колонки самі підлаштовуються під ширину\n       колонки-контейнера, тому сітка ніколи не «вилазить» під кошик */\n    grid-template-columns: repeat(auto-fill, minmax(8.5rem, 1fr));\n    gap: var(--rc-space-3);\n}\n\n/* На великому екрані плитка — основна ціль для миші й пальця,\n   тому вона помітно більша, ніж у щільній мобільній сітці */\n@media (min-width: 1024px) {\n    .rc-catalog-grid {\n        grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));\n        gap: var(--rc-space-4);\n    }\n}\n\n.rc-catalog-tile {\n    display: flex;\n    flex-direction: column;\n    /* min-width: 0 обов'язковий: без нього довга назва товару розтягує\n       колонку grid-у і ламає макет */\n    min-width: 0;\n    min-height: 8.5rem;\n    padding: var(--rc-space-3);\n    border: 1px solid var(--rc-border);\n    border-radius: var(--rc-radius);\n    background: var(--rc-surface);\n    box-shadow: var(--rc-shadow-sm);\n    color: var(--rc-text);\n    font-family: inherit;\n    text-align: left;\n    cursor: pointer;\n    transition: transform 0.12s, box-shadow 0.15s, border-color 0.15s;\n}\n\n.rc-catalog-tile:hover {\n    box-shadow: var(--rc-shadow);\n    border-color: var(--rc-border-strong);\n}\n\n.rc-catalog-tile:active {\n    transform: scale(0.98);\n}\n\n.rc-catalog-tile__media {\n    flex: 0 0 auto;\n    height: 3.5rem;\n    margin-bottom: var(--rc-space-2);\n    border-radius: var(--rc-radius-sm);\n    background-color: var(--rc-surface-sunken);\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--rc-text-subtle);\n    font-size: 1.75rem;\n}\n\n/* На телефоні порожній плейсхолдер лише крав би місце в назви */\n.rc-catalog-tile__media--empty {\n    display: none;\n}\n\n.rc-catalog-tile__name {\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.3;\n    /* Обрізаємо довгі назви двома рядками замість зменшення шрифту */\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.rc-catalog-tile__meta {\n    margin-top: 0.125rem;\n    font-size: 0.75rem;\n    color: var(--rc-text-subtle);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.rc-catalog-tile__price {\n    margin-top: auto;\n    padding-top: var(--rc-space-2);\n    font-weight: 700;\n    font-size: 0.9375rem;\n}\n\n/* Групи товарів виглядають інакше, ніж самі товари */\n.rc-catalog-tile--group {\n    align-items: flex-start;\n    /* Назва й підпис «Категорія» тримаються разом угорі: після\n       збільшення плиток space-between розганяв їх по кутах */\n    justify-content: flex-start;\n    background: linear-gradient(180deg, var(--rc-surface) 0%, var(--rc-surface-sunken) 100%);\n}\n\n.rc-catalog-tile--group .rc-catalog-tile__meta {\n    margin-top: 0.125rem;\n}\n\n.rc-catalog-tile--group .rc-catalog-tile__media {\n    background: none;\n    height: 2rem;\n    justify-content: flex-start;\n    color: var(--rc-brand-red);\n}\n\n.rc-catalog-tile--nav {\n    min-height: 5rem;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    background: var(--rc-surface-sunken);\n    box-shadow: none;\n}\n\n.rc-catalog-tile--nav .rc-catalog-tile__name {\n    text-align: center;\n    color: var(--rc-text-muted);\n}\n\n/* На десктопі плитка — основна ціль для миші: вища, з просторішим\n   padding-ом і більшим шрифтом назви та ціни. Мобільна сітка щільна\n   навмисно, тому ці розміри лишаються всередині медіа-запиту. */\n@media (min-width: 1024px) {\n    .rc-catalog-tile {\n        min-height: 13.5rem;\n        padding: var(--rc-space-4);\n    }\n\n    .rc-catalog-tile__media {\n        height: 6rem;\n        margin-bottom: var(--rc-space-3);\n    }\n\n    .rc-catalog-tile__media--empty {\n        display: flex;\n    }\n\n    .rc-catalog-tile__name {\n        font-size: 1rem;\n    }\n\n    .rc-catalog-tile__meta {\n        font-size: 0.8125rem;\n    }\n\n    .rc-catalog-tile__price {\n        font-size: 1.125rem;\n        padding-top: var(--rc-space-3);\n    }\n\n    /* У категорії немає ні картинки, ні ціни, тож на високій плитці\n       вміст центруємо — інакше під підписом лишається порожня третина */\n    .rc-catalog-tile--group {\n        justify-content: center;\n    }\n\n    .rc-catalog-tile--group .rc-catalog-tile__media {\n        height: 3rem;\n        font-size: 2.25rem;\n    }\n}\n\n.rc-catalog-pager {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: var(--rc-space-2);\n    padding-top: var(--rc-space-4);\n}\n\n.rc-catalog-pager .p-button {\n    flex: none;\n}\n\n.rc-catalog-pager .rc-page-subtitle {\n    white-space: nowrap;\n}\n\n/* На вузькому екрані три підписи в один ряд не вміщаються, а flex: none\n   не дає їм стиснутись — «Наступна» вилазила за межі екрана. Ховаємо\n   текст візуально (не з DOM: доступна назва кнопки лишається). */\n@media (max-width: 599px) {\n    .rc-catalog-pager .p-button .p-button-label {\n        position: absolute;\n        width: 1px;\n        height: 1px;\n        overflow: hidden;\n        clip-path: inset(50%);\n        white-space: nowrap;\n    }\n\n    .rc-catalog-pager .p-button .p-button-icon {\n        margin: 0;\n    }\n}\n\n/* ── Вибір розділу (товари / послуги) ──────────────────────────────── */\n\n.rc-picker-grid {\n    display: grid;\n    gap: var(--rc-space-4);\n    grid-template-columns: 1fr;\n}\n\n@media (min-width: 600px) {\n    .rc-picker-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n.rc-picker {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--rc-space-2);\n    min-height: 9rem;\n    padding: var(--rc-space-5);\n    border: 1px solid var(--rc-border);\n    border-radius: var(--rc-radius-lg);\n    background: var(--rc-surface);\n    box-shadow: var(--rc-shadow-sm);\n    color: var(--rc-text);\n    font-family: inherit;\n    text-align: left;\n    cursor: pointer;\n    transition: transform 0.12s, box-shadow 0.15s;\n}\n\n.rc-picker:hover {\n    box-shadow: var(--rc-shadow);\n}\n\n.rc-picker:active {\n    transform: scale(0.99);\n}\n\n.rc-picker__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 3rem;\n    height: 3rem;\n    border-radius: var(--rc-radius);\n    background: var(--rc-outcome-soft);\n    color: var(--rc-brand-red);\n    font-size: 1.5rem;\n}\n\n.rc-picker__title {\n    font-size: 1.125rem;\n    font-weight: 700;\n}\n\n.rc-picker__hint {\n    font-size: 0.875rem;\n    color: var(--rc-text-muted);\n}\n\n/* ─────────────────────────────────────────────────────────────────────\n   Кошик і списки позицій\n   ───────────────────────────────────────────────────────────────────── */\n\n.rc-line-item {\n    display: flex;\n    align-items: center;\n    gap: var(--rc-space-3);\n    padding: var(--rc-space-3) var(--rc-space-4);\n    border-top: 1px solid var(--rc-border);\n}\n\n.rc-line-item:first-child {\n    border-top: 0;\n}\n\n.rc-line-item__main {\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n.rc-line-item__name {\n    font-weight: 600;\n    font-size: 0.9375rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.rc-line-item__meta {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0 var(--rc-space-2);\n    margin-top: 0.125rem;\n    min-width: 0;\n    font-size: 0.8125rem;\n    color: var(--rc-text-muted);\n}\n\n.rc-line-item__side {\n    display: flex;\n    align-items: center;\n    gap: var(--rc-space-2);\n    flex: none;\n}\n\n/* Лічильник кількості — великі цілі для пальця */\n.rc-stepper {\n    display: inline-flex;\n    align-items: center;\n    border: 1px solid var(--rc-border);\n    border-radius: var(--rc-radius-pill);\n    background: var(--rc-surface);\n    overflow: hidden;\n}\n\n.rc-stepper__btn {\n    width: 2.25rem;\n    height: 2.25rem;\n    border: 0;\n    background: none;\n    color: var(--rc-text-muted);\n    font-size: 0.875rem;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.rc-stepper__btn:hover:not(:disabled) {\n    background: var(--rc-neutral-soft);\n    color: var(--rc-text);\n}\n\n.rc-stepper__btn:disabled {\n    opacity: 0.35;\n    cursor: not-allowed;\n}\n\n.rc-stepper__value {\n    min-width: 2rem;\n    text-align: center;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n}\n\n/* Перелік позицій на кроці оплати. Обмежуємо висоту: із двадцятьма\n   позиціями кнопка «Оплатити» інакше опинялася б далеко за екраном,\n   і касир мусив би гортати сторінку на кожен продаж. */\n.rc-checkout-items {\n    /* На телефоні висоту обмежуємо, інакше на великому замовленні кнопка\n       «Оплатити» йде далеко за екран. 60vh — це 5-6 рядків, тобто типове\n       замовлення вміщається повністю й нічого не обрізається. */\n    max-height: 60vh;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n    /* Згасання біля нижнього краю, коли рядки все ж не вмістилися:\n       інакше останній обрізається посередині тексту й читається\n       як помилка відображення, а не як «список продовжується». */\n    mask-image: linear-gradient(to bottom, #000 calc(100% - 1.5rem), transparent 100%);\n    -webkit-mask-image: linear-gradient(to bottom, #000 calc(100% - 1.5rem), transparent 100%);\n}\n\n/* На десктопі обмеження не потрібне: вертикального місця вдосталь,\n   а обрізаний рядок виглядає як дефект верстки. Показуємо весь список. */\n@media (min-width: 1024px) {\n    .rc-checkout-items {\n        max-height: none;\n        overflow-y: visible;\n        mask-image: none;\n        -webkit-mask-image: none;\n    }\n}\n\n\n/* ── Панель кошика ─────────────────────────────────────────────────── */\n\n.rc-cart {\n    display: flex;\n    flex-direction: column;\n    /* flex + min-height: 0 — щоб усередині обмеженого по висоті контейнера\n       стискався саме список позицій, а не «виїжджав» підвал із кнопкою */\n    flex: 1 1 auto;\n    height: 100%;\n    min-height: 0;\n}\n\n.rc-cart__list {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n}\n\n.rc-cart__footer {\n    flex: none;\n    padding: var(--rc-space-4);\n    /* На телефоні кошик відкривається панеллю на весь екран, і його підвал\n       упирається в нижній край. Без відступу на safe-area кнопка «Перейти\n       до оплати» частково ховається під жестовою смугою iPhone — на\n       десктопі --rc-safe-bottom дорівнює 0, тож правило там ні на що не\n       впливає. */\n    padding-bottom: calc(var(--rc-space-4) + var(--rc-safe-bottom));\n    border-top: 1px solid var(--rc-border);\n    background: var(--rc-surface);\n}\n\n.rc-cart__total {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: var(--rc-space-3);\n    margin-bottom: var(--rc-space-3);\n}\n\n.rc-cart__total-label {\n    color: var(--rc-text-muted);\n    font-size: 0.875rem;\n}\n\n.rc-cart__total-value {\n    font-size: 1.5rem;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n    font-variant-numeric: tabular-nums;\n}\n\n/* Десктопна колонка кошика «прилипає» до екрана */\n.rc-cart-column {\n    display: none;\n}\n\n@media (min-width: 1024px) {\n    .rc-sale-layout {\n        display: grid;\n        grid-template-columns: minmax(0, 1fr) 22rem;\n        gap: var(--rc-space-4);\n        align-items: start;\n    }\n\n    .rc-sale-layout > * {\n        min-width: 0;\n    }\n\n    .rc-cart-column {\n        /* Над колонкою кошика стоїть липка панель каталогу, тому відлік\n           ведемо від її низу, а не від низу шапки: інакше картка кошика\n           і прилипала під панель, і виростала нижче екрана — підвал із\n           кнопкою «Перейти до оплати» опинявся за межами вікна, щойно\n           позицій ставало більше шести. Висоту панелі беремо з запасом. */\n        --rc-cart-top: calc(\n            var(--rc-header-h) + var(--rc-safe-top) + var(--rc-catalog-toolbar-h) + var(--rc-space-3)\n        );\n        --rc-cart-max-h: calc(100vh - var(--rc-cart-top) - var(--rc-space-4));\n\n        display: block;\n        position: sticky;\n        top: var(--rc-cart-top);\n        max-height: var(--rc-cart-max-h);\n    }\n\n    .rc-cart-column .rc-card {\n        max-height: var(--rc-cart-max-h);\n        display: flex;\n        flex-direction: column;\n    }\n\n    /* Без цього тіло картки лишалося блоком висотою за вмістом: height: 100%\n       у .rc-cart не мав від чого рахуватися, список не прокручувався, а\n       overflow: hidden на картці зрізав підвал із кнопкою «Перейти до\n       оплати» — вона зникала, щойно позицій ставало більше шести. */\n    .rc-cart-column .rc-card__body {\n        display: flex;\n        flex-direction: column;\n        flex: 1 1 auto;\n        min-height: 0;\n    }\n}\n\n/* ─────────────────────────────────────────────────────────────────────\n   Панелі (Sidebar) — форми оплати, вибір клієнта тощо\n   ───────────────────────────────────────────────────────────────────── */\n\n.rc-drawer.p-sidebar {\n    width: 100%;\n    max-width: 30rem;\n    /* PrimeReact дає панелі height: 100%, а для position: fixed це висота\n       «великого» вікна — без урахування адресного рядка мобільного\n       браузера. Тому низ панелі (а з ним і кнопка «Перейти до оплати»)\n       опинявся за краєм видимої області, доки користувач не прокрутить\n       сторінку й рядок не сховається. 100dvh рахує саме видиму висоту;\n       для старих браузерів лишається запасне 100%. */\n    height: 100%;\n    height: 100dvh;\n}\n\n.rc-drawer.p-sidebar .p-sidebar-header {\n    padding: var(--rc-space-3) var(--rc-space-4);\n    border-bottom: 1px solid var(--rc-border);\n}\n\n.rc-drawer.p-sidebar .p-sidebar-content {\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n    min-height: 0;\n}\n\n.rc-drawer__title {\n    font-size: 1rem;\n    font-weight: 600;\n}\n\n.rc-drawer__body {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    padding: var(--rc-space-4);\n}\n\n.rc-drawer__body--flush {\n    padding: 0;\n}\n\n/* Дії панелі завжди видно внизу, над жестовою смугою */\n.rc-drawer__footer {\n    flex: none;\n    display: flex;\n    flex-direction: column;\n    gap: var(--rc-space-2);\n    padding: var(--rc-space-4);\n    padding-bottom: calc(var(--rc-space-4) + var(--rc-safe-bottom));\n    border-top: 1px solid var(--rc-border);\n    background: var(--rc-surface);\n}\n\n/* Повноекранна панель сканера */\n.rc-scanner.p-sidebar {\n    /* Та сама причина, що й у .rc-drawer: інакше кнопки «Закрити» і\n       «Підсвітка» з’їжджають під адресний рядок мобільного браузера */\n    height: 100%;\n    height: 100dvh;\n}\n\n.rc-scanner.p-sidebar .p-sidebar-content {\n    padding: 0;\n    background: #000;\n}\n\n/* Власна шапка панелі світла й перекриває відео — у сканера є своя\n   кнопка «Закрити», тож стандартну ховаємо (Esc і далі працює) */\n.rc-scanner.p-sidebar .p-sidebar-header {\n    display: none;\n}\n\n.rc-scanner__stage {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    background: #000;\n}\n\n.rc-scanner__video {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n/* Рамка збігається з ділянкою, яку насправді декодує хук (ROI у\n   useBarcodeScanner): 80% ширини кадру на 45% висоти. Якщо міняєте\n   ROI — міняйте й ці числа, інакше касир наводитиме не туди. */\n.rc-scanner__frame {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    /* Висота збігається з ROI.height у useBarcodeScanner.js.\n       По ширині рамка майже на весь екран: декодер бачить ще ширше,\n       тож код зчитається, навіть якщо трохи виходить за краї. */\n    width: 94%;\n    height: 40%;\n    border: 2px solid rgba(255, 255, 255, 0.9);\n    border-radius: var(--rc-radius);\n    box-shadow: 0 0 0 100vmax rgba(0, 0, 0, 0.5);\n    pointer-events: none;\n}\n\n.rc-scanner__hint {\n    position: absolute;\n    left: var(--rc-space-4);\n    right: var(--rc-space-4);\n    bottom: calc(5.5rem + var(--rc-safe-bottom));\n    text-align: center;\n    color: rgba(255, 255, 255, 0.92);\n    font-size: 0.9375rem;\n    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);\n    pointer-events: none;\n}\n\n/* Стан замість чорного екрана: вмикаємо камеру / немає дозволу тощо */\n.rc-scanner__overlay {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: var(--rc-space-3);\n    padding: var(--rc-space-6) var(--rc-space-5);\n    text-align: center;\n    color: #fff;\n    background: rgba(20, 21, 26, 0.92);\n}\n\n.rc-scanner__overlay i {\n    font-size: 2.5rem;\n    color: rgba(255, 255, 255, 0.75);\n}\n\n.rc-scanner__overlay p {\n    margin: 0;\n    max-width: 22rem;\n}\n\n.rc-scanner__overlay-title {\n    font-size: 1.125rem;\n    font-weight: 600;\n}\n\n.rc-scanner__overlay-text {\n    color: rgba(255, 255, 255, 0.75);\n    font-size: 0.9375rem;\n    line-height: 1.5;\n}\n\n.rc-scanner__actions {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: calc(var(--rc-space-4) + var(--rc-safe-bottom));\n    display: flex;\n    justify-content: center;\n    gap: var(--rc-space-3);\n    padding: 0 var(--rc-space-4);\n}\n\n/* ── Рядок «валюта + сума» у формах оплати ─────────────────────────── */\n\n.rc-payment-row {\n    padding: var(--rc-space-3) 0;\n    border-top: 1px solid var(--rc-border);\n}\n\n.rc-payment-row:first-child {\n    border-top: 0;\n    padding-top: 0;\n}\n\n.rc-payment-row__top {\n    display: flex;\n    align-items: center;\n    gap: var(--rc-space-2);\n}\n\n.rc-payment-row__amount {\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n.rc-payment-row__currency {\n    flex: none;\n    width: 6.25rem;\n}\n\n.rc-payment-row__method {\n    margin-top: var(--rc-space-2);\n}\n\n.rc-payment-row .p-dropdown,\n.rc-payment-row .p-inputnumber,\n.rc-payment-row .p-inputtext {\n    width: 100%;\n}\n\n.rc-field-error {\n    display: block;\n    margin-top: var(--rc-space-1);\n    color: var(--rc-outcome-strong);\n    font-size: 0.8125rem;\n}\n\n.rc-field-hint {\n    display: block;\n    margin-top: var(--rc-space-1);\n    color: var(--rc-text-muted);\n    font-size: 0.8125rem;\n}\n\n.rc-field {\n    margin-bottom: var(--rc-space-4);\n}\n\n.rc-field__label {\n    display: block;\n    margin-bottom: var(--rc-space-2);\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: var(--rc-text);\n}\n\n.rc-field .p-inputtext,\n.rc-field .p-dropdown,\n.rc-field .p-calendar,\n.rc-field .p-password,\n/* Password із toggleMask загортає інпут ще в один div.p-icon-field —\n   без нього поле пароля виходило вужчим за поле логіна на ширину іконки */\n.rc-field .p-password .p-icon-field,\n.rc-field .p-password .p-inputtext {\n    width: 100%;\n}\n\n/* ─────────────────────────────────────────────────────────────────────\n   Порожні стани, завантаження\n   ───────────────────────────────────────────────────────────────────── */\n\n.rc-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: var(--rc-space-2);\n    padding: var(--rc-space-6) var(--rc-space-4);\n    text-align: center;\n    color: var(--rc-text-muted);\n}\n\n.rc-empty__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 3.5rem;\n    height: 3.5rem;\n    border-radius: 50%;\n    background: var(--rc-surface-sunken);\n    color: var(--rc-text-subtle);\n    font-size: 1.5rem;\n}\n\n.rc-empty__title {\n    font-weight: 600;\n    color: var(--rc-text);\n}\n\n.rc-empty__text {\n    font-size: 0.875rem;\n    max-width: 22rem;\n}\n\n/* ─────────────────────────────────────────────────────────────────────\n   Двоколонковий макет «список + деталі»\n   ───────────────────────────────────────────────────────────────────── */\n\n.rc-split {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: var(--rc-space-4);\n    align-items: start;\n}\n\n.rc-split > * {\n    min-width: 0;\n}\n\n@media (min-width: 1024px) {\n    .rc-split {\n        grid-template-columns: minmax(0, 24rem) minmax(0, 1fr);\n    }\n\n    .rc-split__aside {\n        position: sticky;\n        top: calc(var(--rc-header-h) + var(--rc-safe-top) + var(--rc-space-4));\n    }\n}\n\n/* На вузьких екранах деталі відкриваються панеллю, а не другою колонкою */\n.rc-split__detail--mobile-hidden {\n    display: none;\n}\n\n@media (min-width: 1024px) {\n    .rc-split__detail--mobile-hidden {\n        display: block;\n    }\n}\n\n/* ── Рядок списку, по якому можна тапнути ──────────────────────────── */\n\n.rc-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.rc-list-item {\n    display: flex;\n    align-items: center;\n    gap: var(--rc-space-3);\n    width: 100%;\n    min-height: var(--rc-touch-target);\n    padding: var(--rc-space-3) var(--rc-space-4);\n    border: 0;\n    border-top: 1px solid var(--rc-border);\n    background: none;\n    color: inherit;\n    font-family: inherit;\n    text-align: left;\n    cursor: pointer;\n    transition: background 0.15s;\n}\n\n.rc-list > .rc-list-item:first-child,\n.rc-list > li:first-child .rc-list-item {\n    border-top: 0;\n}\n\n.rc-list-item:hover {\n    background: var(--rc-surface-sunken);\n}\n\n.rc-list-item--active {\n    background: var(--rc-outcome-soft);\n}\n\n.rc-list-item--active:hover {\n    background: var(--rc-outcome-soft);\n}\n\n.rc-list-item__main {\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n.rc-list-item__title {\n    font-weight: 600;\n    font-size: 0.9375rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.rc-list-item__meta {\n    display: flex;\n    align-items: center;\n    gap: var(--rc-space-2);\n    margin-top: 0.125rem;\n    min-width: 0;\n    font-size: 0.8125rem;\n    color: var(--rc-text-muted);\n}\n\n.rc-list-item__meta > span,\n.rc-line-item__meta > span {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.rc-list-item__meta > i,\n.rc-line-item__meta > i {\n    flex: none;\n}\n\n.rc-list-item__side {\n    flex: none;\n    display: flex;\n    align-items: center;\n    gap: var(--rc-space-2);\n    text-align: right;\n}\n\n.rc-list-pager {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: var(--rc-space-3);\n    padding: var(--rc-space-3) var(--rc-space-4);\n    border-top: 1px solid var(--rc-border);\n    font-size: 0.8125rem;\n    color: var(--rc-text-muted);\n}\n\n/* ─────────────────────────────────────────────────────────────────────\n   Екран входу\n   ───────────────────────────────────────────────────────────────────── */\n\n.rc-login {\n    display: grid;\n    grid-template-columns: 1fr;\n    min-height: 100vh;\n    min-height: 100dvh;\n    background: var(--rc-brand-black);\n}\n\n@media (min-width: 900px) {\n    .rc-login {\n        grid-template-columns: minmax(24rem, 32rem) 1fr;\n    }\n}\n\n.rc-login__panel {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: var(--rc-space-6) var(--rc-space-4);\n    padding-top: calc(var(--rc-space-6) + var(--rc-safe-top));\n    padding-bottom: calc(var(--rc-space-6) + var(--rc-safe-bottom));\n}\n\n.rc-login__card {\n    width: 100%;\n    max-width: 24rem;\n    margin: 0 auto;\n    padding: var(--rc-space-5);\n    border-radius: var(--rc-radius-lg);\n    background: var(--rc-surface);\n    box-shadow: var(--rc-shadow-lg);\n}\n\n.rc-login__brand {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: var(--rc-space-2);\n    margin-bottom: var(--rc-space-5);\n    text-align: center;\n}\n\n.rc-login__logo {\n    width: 3.5rem;\n    height: 3.5rem;\n    object-fit: contain;\n}\n\n.rc-login__wordmark {\n    font-size: 1.5rem;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n}\n\n.rc-login__wordmark em {\n    font-style: normal;\n    color: var(--rc-brand-red);\n}\n\n.rc-login__hint {\n    font-size: 0.875rem;\n    color: var(--rc-text-muted);\n}\n\n.rc-login__footer {\n    margin-top: var(--rc-space-5);\n    text-align: center;\n    font-size: 0.75rem;\n    color: var(--rc-text-subtle);\n}\n\n.rc-login__art {\n    display: none;\n    background-size: cover;\n    background-position: center;\n    position: relative;\n}\n\n@media (min-width: 900px) {\n    .rc-login__art {\n        display: block;\n    }\n}\n\n.rc-login__art::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(90deg, rgba(20, 21, 26, 0.55) 0%, rgba(20, 21, 26, 0) 45%);\n}\n\n/* ─────────────────────────────────────────────────────────────────────\n   Точкові налаштування компонентів PrimeReact\n   ───────────────────────────────────────────────────────────────────── */\n\n/* Мінімальні сенсорні цілі для полів і кнопок */\n.p-button {\n    min-height: var(--rc-touch-target);\n    border-radius: var(--rc-radius-sm);\n    font-weight: 600;\n}\n\n.p-button.p-button-sm {\n    min-height: 2.25rem;\n}\n\n.p-button.p-button-icon-only.p-button-rounded {\n    border-radius: 50%;\n}\n\n.p-inputtext,\n.p-dropdown,\n.p-calendar .p-inputtext {\n    min-height: var(--rc-touch-target);\n    border-radius: var(--rc-radius-sm);\n    /* 16px не дає iOS Safari зумити сторінку під час фокусу на полі */\n    font-size: 1rem;\n}\n\n.p-inputnumber-input {\n    text-align: right;\n}\n\n.p-dropdown .p-dropdown-label {\n    display: flex;\n    align-items: center;\n}\n\n/* Toast над нижньою навігацією */\n.p-toast {\n    max-width: calc(100vw - 2 * var(--rc-space-3));\n}\n\n/* Модальні вікна на мобільному займають усю ширину */\n.p-dialog {\n    width: calc(100vw - 2 * var(--rc-space-4));\n    max-width: 28rem;\n    border-radius: var(--rc-radius);\n}\n\n.p-dialog .p-dialog-content:last-of-type {\n    border-radius: 0 0 var(--rc-radius) var(--rc-radius);\n}\n\n/* Повідомлення (Message) на всю ширину панелі */\n.rc-message.p-message {\n    width: 100%;\n    margin: 0 0 var(--rc-space-3);\n    border-radius: var(--rc-radius-sm);\n}\n\n.rc-message.p-message .p-message-wrapper {\n    padding: var(--rc-space-3);\n}\n\n/* Таби історії — рівномірні, з великими цілями */\n.rc-tabs .p-tabview-nav {\n    border-radius: var(--rc-radius) var(--rc-radius) 0 0;\n}\n\n.rc-tabs .p-tabview-nav li {\n    flex: 1 1 0;\n}\n\n.rc-tabs .p-tabview-nav li .p-tabview-nav-link {\n    justify-content: center;\n    min-height: var(--rc-touch-target);\n    padding: var(--rc-space-3);\n}\n\n.rc-tabs .p-tabview-panels {\n    padding: 0;\n    border-radius: 0 0 var(--rc-radius) var(--rc-radius);\n}\n\n/* Прибираємо анімацію для тих, хто її не переносить */\n@media (prefers-reduced-motion: reduce) {\n    *,\n    *::before,\n    *::after {\n        animation-duration: 0.01ms !important;\n        animation-iteration-count: 1 !important;\n        transition-duration: 0.01ms !important;\n        scroll-behavior: auto !important;\n    }\n}\n\n/* Друк: лишаємо тільки вміст */\n@media print {\n    .rc-header,\n    .rc-bottom-nav,\n    .rc-catalog-toolbar {\n        display: none !important;\n    }\n\n    .rc-main {\n        padding: 0;\n        max-width: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
